import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EtiquetasGestionComponent } from './components/etiquetas-gestion/etiquetas-gestion.component';

const routes: Routes = [
  {
    path: "gestionar",
    component: EtiquetasGestionComponent,
    data: {
      title: 'Etiquetas nog'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EtiquetasGestionRoutingModule { }
